import axios from 'axios';
import qs from 'qs';
import * as apiURL from './apiConfig';

export const getProducts = async (productSlug, params) => {
  let url = apiURL.PRODUCT_URL;
  if (productSlug) {
    url = `${url}/${productSlug}`;
  }
  let newParams = null;
  if (params) {
    const { current, pageSize = 12, total, ...rest } = params;
    newParams = {
      ...rest,
      skip: (current - 1) * pageSize,
      limit: pageSize,
    };
  }

  try {
    const response = await axios.get(url, {
      params: newParams,
      paramsSerializer: (data) => {
        return qs.stringify(data, {
          arrayFormat: 'repeat',
          plainObjects: true,
        });
      },
    });
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getProductReviews = async (product, params) => {
  const { current, pageSize = 4, total, ...rest } = params;
  const newParams = {
    ...rest,
    skip: (current - 1) * pageSize,
    limit: pageSize,
  };

  try {
    const response = await axios.get(
      `${apiURL.PRODUCT_REVIEW_URL}/${product}`,
      {
        params: newParams,
        paramsSerializer: (data) => {
          return qs.stringify(data, {
            arrayFormat: 'repeat',
            plainObjects: true,
          });
        },
      }
    );
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getRelatedProducts = async (slug) => {
  try {
    const response = await axios.get(`${apiURL.RELATED_PRODUCT_URL}/${slug}`);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const putRecentlyViewed = async (productId) => {
  try {
    const response = await axios.put(`${apiURL.RECENT_VIEW_URL}/${productId}`);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
